import React, { useState, useEffect } from 'react';
import { validateToken } from '../api/AuthAPIs';

let token = localStorage.getItem('token') || null;
let role = localStorage.getItem('role') || 'User';

export const setToken = (newToken) => {
  token = newToken;
  if (newToken) {
    localStorage.setItem('token', newToken);
  } else {
    localStorage.removeItem('token');
  }
};

export const getToken = () => token;

export const clearToken = () => {
  token = null;
  localStorage.removeItem('token');
};

export const setRole = (newRole) => {
  role = newRole;
  localStorage.setItem('role', newRole);
};

export const getRole = () => role;

const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
  const [authState, setAuthState] = useState({
    token: getToken(),
    role: getRole(),
    isValidating: true, // Track validation state
  });

  useEffect(() => {
    const validate = async () => {
      const currentToken = getToken();
      if (currentToken) {
        try {
          await validateToken(currentToken); // Validate token with the backend
          setAuthState({ token: currentToken, role: getRole(), isValidating: false });
          console.log('Token validated successfully:', { token: currentToken, role: getRole() });
        } catch (err) {
          console.error('Token validation failed:', err.message);
          clearToken();
          setRole('User');
          setAuthState({ token: null, role: 'User', isValidating: false });
        }
      } else {
        setAuthState({ token: null, role: 'User', isValidating: false });
      }
    };
    validate();
  }, []);

  const updateAuth = (newToken, newRole) => {
    setToken(newToken);
    setRole(newRole);
    setAuthState({ token: newToken, role: newRole, isValidating: false });
    console.log('Auth state updated:', { token: newToken, role: newRole });
  };

  const logout = () => {
    clearToken();
    setRole('User');
    setAuthState({ token: null, role: 'User', isValidating: false });
    console.log('Logged out, auth state:', { token: null, role: 'User' });
  };

  return (
    <AuthContext.Provider value={{ authState, updateAuth, logout }}>
      {authState.isValidating ? (
        <div className="min-h-screen flex items-center justify-center">
          <p className="text-lg">جارٍ التحقق من تسجيل الدخول...</p>
        </div>
      ) : (
        children
      )}
    </AuthContext.Provider>
  );
};

export const useAuth = () => React.useContext(AuthContext);